import { render } from "./IconLink.vue?vue&type=template&id=0f34851a"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"
script.render = render

export default script